/*
  Houdt de teller in de header op het ZICHTBARE aantal artikelen.

  Een vloerkleed op maat staat als bedrag-in-euro's in `quantity` op een hulpvariant
  van EUR 1,00, omdat dit Shopify-plan geen vrije regelprijs toestaat. De thema-JS
  schrijft `cart.item_count` in de badge en dan leest een kleed van EUR 287 als 287.
  Regels met de verborgen eigenschap `_toon_als_aantal` tellen als het aantal kleden:
  quantity gedeeld door `_eenheden` (het bedrag van een kleed), zie vm-maatwerk-stuks.liquid.

  Puur cosmetisch, en bewust defensief: valt dit script uit, dan staat er weer het
  ruwe aantal, maar er gaat niets stuk aan de winkelwagen zelf.
*/
(function () {
  "use strict";
  var BADGE = "[data-header-cart-count]";

  function zichtbaarAantal(winkelwagen) {
    var regels = (winkelwagen && winkelwagen.items) || [];
    var totaal = 0;
    for (var i = 0; i < regels.length; i++) {
      var props = regels[i].properties || {};
      if (props._toon_als_aantal) {
        var e = parseInt(props._eenheden, 10);
        totaal += e > 0 ? Math.max(1, Math.floor((regels[i].quantity || 0) / e)) : 1;
      } else {
        totaal += regels[i].quantity || 0;
      }
    }
    return totaal;
  }

  var bezig = false;
  function schrijf(aantal) {
    var el = document.querySelector(BADGE);
    if (!el) return;
    var tekst = aantal > 0 ? String(aantal) : "";
    if (el.getAttribute("data-header-cart-count") === tekst) return;
    bezig = true;
    el.setAttribute("data-header-cart-count", tekst);
    el.classList.toggle("visible", aantal > 0);
    bezig = false;
  }

  var laatste = null;
  function verversVanServer() {
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (w) { if (w) { laatste = w; schrijf(zichtbaarAantal(w)); } })
      .catch(function () {});
  }

  window.addEventListener("cartcount:update", function (e) {
    if (e && e.detail && e.detail.items) { laatste = e.detail; schrijf(zichtbaarAantal(e.detail)); }
    else verversVanServer();
  });

  // De thema-JS schrijft na elke eigen update opnieuw het ruwe aantal in de badge.
  // Corrigeer dat terug, zonder op onze eigen schrijfactie te reageren.
  function bewaak() {
    var el = document.querySelector(BADGE);
    if (!el || typeof MutationObserver !== "function") return;
    new MutationObserver(function () {
      if (bezig) return;
      if (laatste) schrijf(zichtbaarAantal(laatste));
      else verversVanServer();
    }).observe(el, { attributes: true, attributeFilter: ["data-header-cart-count"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bewaak);
  else bewaak();
})();
